import React from 'react';
import { Car, Home, Calendar } from 'lucide-react';

/**
 * Компонент выбора типа объекта налогообложения (автомобиль или недвижимость)
 */
const ObjectTypeSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {/* Выбор типа объекта */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Тип объекта налогообложения
          </label>
          <div className="grid grid-cols-2 gap-3">
            <label className={`flex items-center justify-center p-4 rounded-lg border ${
              formData.taxObjectType === 'car' 
                ? 'bg-indigo-50 border-indigo-200 text-indigo-800 dark:bg-indigo-900/30 dark:border-indigo-700 dark:text-indigo-200' 
                : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-700/70'
              } cursor-pointer transition-colors`}>
              <input
                type="radio"
                name="taxObjectType"
                value="car"
                checked={formData.taxObjectType === 'car'}
                onChange={handleInputChange}
                className="sr-only"
              />
              <div className="flex flex-col items-center">
                <Car className="w-8 h-8 mb-2" />
                <span className="font-medium">Автомобиль</span>
              </div>
            </label>
            <label className={`flex items-center justify-center p-4 rounded-lg border ${
              formData.taxObjectType === 'property' 
                ? 'bg-indigo-50 border-indigo-200 text-indigo-800 dark:bg-indigo-900/30 dark:border-indigo-700 dark:text-indigo-200' 
                : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-700/70'
              } cursor-pointer transition-colors`}>
              <input
                type="radio"
                name="taxObjectType"
                value="property"
                checked={formData.taxObjectType === 'property'}
                onChange={handleInputChange}
                className="sr-only"
              />
              <div className="flex flex-col items-center">
                <Home className="w-8 h-8 mb-2" />
                <span className="font-medium">Недвижимость</span>
              </div>
            </label>
          </div>
          {errors.taxObjectType && (
            <p className="mt-2 text-sm text-red-600 dark:text-red-500">{errors.taxObjectType}</p>
          )}
        </div>

        {/* Выбор года */}
        <div>
          <label htmlFor="year" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex items-center">
            <Calendar className="w-4 h-4 mr-2 text-indigo-500" />
            Налоговый период (год)
          </label>
          <select
            id="year"
            name="year"
            value={formData.year}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.year ? 'input-error' : ''}`}
          >
            {Array.from({ length: 5 }, (_, i) => currentYear - i).map((year) => (
              <option key={year} value={year.toString()}>
                {year}
              </option>
            ))}
          </select>
          {errors.year && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.year}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ObjectTypeSection;